import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import Gamestate from "slotworks/model/game-state";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import RetriggerFreespins from "slotworks/state-machine/standard/states/retrigger-freespins";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import Layers from "slotworks/graphics/layers/layers";
import DSComponents from "components/components";
import { PotType } from "components/pots/coinpots-component";
import RevolverSettings from "model/revolver-settings";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

export default class ICRetriggerFreespins extends RetriggerFreespins {
    public onEnter() {
        RevolverSettings.retriggerPending = false;
        DSComponents.coinPots.burstCoins(PotType.FREESPIN, true).then(() => {
            SmartButton.setFlag(SmartButtonFlag.PROMPT, true);  
            Layers.SmartButton.hide();        

            // Gets the last Freespins record, if current record is bonuswheel
            const records = Gamestate.getCurrentGame().records;
            let record = null;
            for(let i = records.length - 1; i >= 0; i--) {
                if(records[i] instanceof FreespinRecord) {
                    record = records[i] as ICFreespinRecord;
                    break;
                }
            }

            // const record = Gamestate.getCurrentGame().getCurrentRecord() as ICFreespinRecord;

            if (Layers.CelebrationBackground.hasScene("glowstack")) {
                Layers.CelebrationBackground.setScene("glowstack").execute();
            }
            const contents = new Map<string, any>();
            contents.set("value", "+" + record.freespinsWon.toString());
            
            Components.prompt.show(["freespinsretrigger"], contents, 2800).then(() => this.complete());
        });
    }

    public complete() {        
        super.complete();
    }

    public onExit() {
        Layers.CelebrationBackground.setScene("default").execute();
        Layers.BetBar.show();     
        Layers.SmartButton.show();  
        super.onExit();
    }
}
